<template>
  <div>
    <post-header :post="post" class="post-header"/>
    <post-body :post="post" :isRepost="false" @setTrust="setTrust"/>

  </div>
</template>

<script>
  // components
  import PostHeader from '@/views/analytics/components/tabs/components/publicationsAndComments/components/PostHeader';
  import PostBody from '@/views/analytics/components/tabs/components/publicationsAndComments//components/PostBody';

  export default {
    name: 'CommentPost',
    props: {
      post: {
        type: Object
      }
    },
    data() {
      return {
        trimTextLength: 400,
      };
    },
    methods: {
      showMore() {
        this.$emit('showMore', this.post);
      },
      setTrust({postId, trust}) {
        this.$emit('setTrust', {post: this.post, trust});
      },
      showMoreButton() {
        return this.post.text.length > this.trimTextLength;
      },
    },
    components: {
      PostHeader,
      PostBody,
    },
  };
</script>
